{"mimecast_ui_package_version":"5.14.7","CDN_BASE_URL":"https://d2hlvp5lfy8w3p.cloudfront.net"}